import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  nbr: number;
  retrieveUnReadNotificationsNbr(
    request: Boundaries["retrieveUnReadNotificationsNbr"]["request"],
  ): void;
}

function useRetrieveUnReadNotificationsNbr(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(
      selector.isRetrieveUnReadNotificationsNbrRequestPending,
    ),
    isRequestSuccess: useSelector(
      selector.isRetrieveUnReadNotificationsNbrRequestSuccess,
    ),
    isRequestFailure: useSelector(
      selector.isRetrieveUnReadNotificationsNbrRequestFailure,
    ),
    nbr: useSelector(selector.getUnReadNotificationsNbr),
    retrieveUnReadNotificationsNbr: core.retrieveUnReadNotificationsNbr,
  };
}

export { useRetrieveUnReadNotificationsNbr };
